var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({class:{
    w100p: _vm.w100p,
    'centered-input': 'center' in _vm.$attrs,
  },attrs:{"x-text-field":"","type":"text","reverse":'right' in _vm.$attrs,"id":_vm.v_id}},'input',Object.assign({}, _vm.$attrs, {value: _vm.value}),false),Object.assign({}, _vm.$listeners,
    {input: function (v){ return _vm.$emit('input',v.target.value); }})))}
var staticRenderFns = []

export { render, staticRenderFns }